module.exports = __webpack_public_path__ + "img/EPF-24D-Goldregen-Studio-9668.129813a2.jpg";